import { Heart } from 'components/gruenland/icons/Heart';

type Props = {
  className?: string;
  totalWishlistItems: number;
};

const Icon: React.FC<Props> = ({ className, totalWishlistItems }: Props) => (
  <>
    {totalWishlistItems > 0 && (
      <span className="absolute right-[-10px] top-[-3px] size-[10px] rounded-full bg-primary-green" />
    )}
    <Heart className={className} />
  </>
);

export default Icon;
